<script lang="ts">

    import "@lottiefiles/lottie-player";
    import { Router, Route } from 'svelte-navigator';
    import Home from './Pages/Home.svelte';
    import Map from './Pages/Map.svelte';
    import Menu from './Pages/Menu.svelte';

    onWindowResize();

    function onWindowResize() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

</script>

<svelte:window on:resize={onWindowResize} />

<Router primary={false}>

    <Route path="/" component={Home} />
    <Route path="/menu" component={Menu} />
    <Route path="/mapa/:routeId" component={Map} />

</Router>
